import React, { useEffect, useState } from 'react';
import { Box, Alert, Button, Typography } from '@mui/material';
import { Close as CloseIcon, Person as PersonIcon } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { useSupabaseClient } from '@supabase/auth-helpers-react';
import { UserProfile } from '../../types/database';

export function ViewingAsBanner() {
  const { viewingAsUserId, setViewingAs, user } = useAuth();
  const supabase = useSupabaseClient();
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null);

  useEffect(() => {
    if (viewingAsUserId && user?.id) {
      supabase
        .from('user_profiles')
        .select('*')
        .eq('user_id', viewingAsUserId)
        .maybeSingle()
        .then(({ data, error }) => {
          if (!error && data) {
            setUserProfile(data);
          }
        });
    } else {
      setUserProfile(null);
    }
  }, [viewingAsUserId, user?.id, supabase]);

  if (!viewingAsUserId || !user) {
    return null;
  }

  const handleStopViewing = () => {
    setViewingAs(null);
  };

  return (
    <Alert
      severity="info"
      icon={<PersonIcon />}
      action={
        <Button color="inherit" size="small" onClick={handleStopViewing} startIcon={<CloseIcon />}>
          Stop Viewing
        </Button>
      }
      sx={{ mb: 2 }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2">
          Viewing as:{' '}
          <strong>
            {userProfile?.full_name || userProfile?.signup_email || 'Loading...'}
          </strong>
        </Typography>
      </Box>
    </Alert>
  );
}

